import React from 'react';
import Toast from '../../../atoms/Toast';

const failureMessage = `This might have happened due to a technical issue.   You can resubmit by clicking on "Edit Feedback" from Order details in My Account >> My Orders`;

const FailureToast = ({
  displayToast = false,
  hideToast
}: {
  displayToast: boolean;
  hideToast: any;
}) => {
  if (displayToast) {
    return (
      <Toast
        message={failureMessage}
        heading="Feedback Submission Failed"
        position="bottom"
        customHeadingClass="rating-feedback-heading"
        visibility
        time={2000}
        customContainerClass="rating-feedback-container"
        customTextClass="rating-feedback-text"
        displayCloseIcon
        onClose={hideToast}
      />
    );
  }
  return null;
};

export default FailureToast;
